import React from 'react';
import { Loader2 } from 'lucide-react';

export interface KeyExtractionLoadingOverlayProps {
  show: boolean;
}

export const KeyExtractionLoadingOverlay: React.FC<KeyExtractionLoadingOverlayProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 100003
    }}>
      <div className="spin" style={{ marginBottom: '16px' }}>
        <Loader2 size={48} color="#3b82f6" />
      </div>
      <p style={{ color: '#ffffff', fontSize: '18px', fontWeight: 600, marginBottom: '8px' }}>
        Extracting Power Legend
      </p>
      <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>
        Analyzing legend table for power symbols and names...
      </p>
    </div>
  );
};
